import { render } from "./ThoughtTrace.vue?vue&type=template&id=39bee87a&scoped=true"
import script from "./ThoughtTrace.vue?vue&type=script&lang=js"
export * from "./ThoughtTrace.vue?vue&type=script&lang=js"

import "./ThoughtTrace.vue?vue&type=style&index=0&id=39bee87a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39bee87a"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
